import styles from "./book.module.scss";
import { convertToCloudFrontUrl } from "../../helper";

const SearchAuthor = (props) => {
    const {
        searchAuthorName,
        handleAuthorSelect,
        authorsData,
        isShowAuthor,
        handleInputChange,
        handleDropdownFocus,
        handleRemoveAuthor,
        handleGetTranslationByLang,
        selectedLang,
        dropdownRef,
        isLoading,
    } = props;

    const selectedAuthors = handleGetTranslationByLang(selectedLang).author || [];

    return (
        <>
            {selectedAuthors.length > 0 && (
                <div className={styles.selectedAuthors}>
                    {selectedAuthors.map((author) => (
                        <span key={author.authorId} className={styles.authorTag}>
                            <span className={styles.authorTagName}>{author.authorName}</span>
                            <button
                                type="button"
                                className={styles.removeAuthorBtn}
                                onClick={() => handleRemoveAuthor(author.authorId, selectedLang)}
                                aria-label={`Remove ${author.authorName}`}
                            >
                                ×
                            </button>
                        </span>
                    ))}
                </div>
            )}

            <div className={styles.authorDropdownContainer} ref={dropdownRef}>
                <div className={styles.inputWrapper}>
                    <svg
                        className={styles.searchIcon}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M14 14L11.1 11.1"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        className={styles.authorSearchInput}
                        placeholder="Search authors by name..."
                        type="text"
                        value={searchAuthorName}
                        onChange={(e) => handleInputChange(e.target.value)}
                        onFocus={handleDropdownFocus}
                    />
                </div>

                {isShowAuthor && (
                    <div className={styles.authorDropdown}>
                        {isLoading ? (
                            <div className={styles.loadingState}>
                                <div className={styles.spinner}></div>
                                <span>Loading...</span>
                            </div>
                        ) : authorsData.length > 0 ? (
                            authorsData.map((author) => {
                                const imageUrl = author.image ? convertToCloudFrontUrl(author.image) : null;
                                const hasValidImage = imageUrl || null;
                                const initials = author.label ? author.label.charAt(0).toUpperCase() : '?';

                                return (
                                    <div
                                        key={author.value}
                                        className={styles.authorOption}
                                        onClick={() => handleAuthorSelect(author, selectedLang)}
                                    >
                                        <div className={styles.authorAvatarWrapper}>
                                            {hasValidImage ? (
                                                <img
                                                    src={imageUrl}
                                                    alt={author.label}
                                                    className={styles.authorAvatar}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        const fallback = e.target.nextElementSibling;
                                                        if (fallback) {
                                                            fallback.style.display = 'flex';
                                                        }
                                                    }}
                                                />
                                            ) : null}
                                            <span
                                                className={styles.authorAvatarFallback}
                                                style={{
                                                    display: hasValidImage ? 'none' : 'flex',
                                                }}
                                            >
                                                {initials}
                                            </span>
                                        </div>
                                        <span className={styles.authorName}>{author.label}</span>
                                    </div>
                                );
                            })
                        ) : authorsData.length === 0 ? (
                            <div className={styles.noResults}>
                                <span>Search authors by name...</span>
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </>
    );
};

export default SearchAuthor;